import React from 'react';
import { WorkoutTypeIcon } from './WorkoutTypeIcon';
import { getWorkoutTypeColor } from '../utils/workoutTypeMeta';
import './workout-type-icon-tile.css';

type TileSize = 'sm' | 'md' | 'lg';

type WorkoutTypeIconTileProps = {
  typeId?: number | null;
  name?: string | null;
  size?: TileSize;
  className?: string;
  tone?: 'sport' | 'completed' | 'incomplete';
};

const ICON_PX: Record<TileSize, number> = { sm: 18, md: 20, lg: 22 };

/** Neumorphic raised tile with sport-specific tint — for pickers, lists, hero badges. */
export function WorkoutTypeIconTile({ typeId, name, size = 'sm', className, tone = 'sport' }: WorkoutTypeIconTileProps) {
  const color = tone === 'completed'
    ? 'var(--workout-completed-color, var(--text-success, #148c4e))'
    : tone === 'incomplete'
      ? 'var(--workout-incomplete-color, var(--text-violet, #6630c4))'
      : getWorkoutTypeColor(typeId, name);
  const tileClass = ['wf-sport-icon-tile', `wf-sport-icon-tile--${size}`, className].filter(Boolean).join(' ');

  return (
    <span
      className={tileClass}
      data-status-tone={tone === 'sport' ? undefined : tone}
      style={{
        '--workout-type-color': color,
        color,
        background: `color-mix(in srgb, ${color} 14%, var(--surface-0, #e8ecf2))`,
      } as React.CSSProperties}
      aria-hidden
    >
      <WorkoutTypeIcon typeId={typeId} name={name} size={ICON_PX[size]} />
    </span>
  );
}
